import { publishEvent } from "../Shared/GoogleTagManager/googleTagManager";
import { storeValue } from "../Shared/GoogleTagManager/gtmSessionStorage";
import { ITTL } from "../Shared/GoogleTagManager/ITTL";

export const contactForm = () => {
  /** Posts a form asynchronously and returns the response HTML. */
  const postForm = (form: HTMLFormElement) =>
    new Promise<string>((resolve, reject) => {
      fetch(form.action, {
        method: "POST",
        body: new FormData(form),
      })
        .then(response => {
          if (response.redirected) {
            // Follow redirect instead of updating the current DOM
            window.location.href = response.url;

            resolve("");
          } else if (response.ok) {
            const contentType = response.headers.get("Content-Type");

            // Redirect to specified URL for applicable responses
            if (contentType && contentType.includes("application/json")) {
              response
                .json()
                .then(json => {
                  const redirectUrl = json.redirectUrl;

                  if (redirectUrl) {                    
                    const arrayOfUrlSegments = redirectUrl.split('/');
                    const lastsegment = arrayOfUrlSegments[arrayOfUrlSegments.length-2];
                    window.location.href = redirectUrl + "?selectedInterests=" + lastsegment;
                  }

                  resolve("");
                })
                .catch(error => reject(error));
            }

            // Non-redirect option, so we update the current DOM if request was successful
            response.text().then(html => resolve(html));
          } else {
            reject();
          }
        })
        .catch(error => {
          reject(error);
        });
    });

  /** Wires up event to post form whenever selected item (e.g. sort order) changes. */
  const wireUpSelectElements = () => {
    const form = document.getElementById("contact-form") as HTMLFormElement;

    form.querySelectorAll<HTMLSelectElement>("select").forEach(elm => {
      elm.addEventListener("change", _ => {
        if (elm.disabled) {
          // Ignore changes to disabled elements
          return;
        }
        
        // Post GTM event when selection changes
        publishEvent("form-value-selected", elm.value);

        // Adds a GTM session storage variable only if user selected "products-and-solutions". Used to display Leave Intent Survey. For more info see: https://tedgustaf.atlassian.net/browse/MON-1164
        if (elm.value === "products-and-solutions") {
          storeValue("products-and-solutions-form-opened", {
            value: true,
            TTL: 1,
          } as ITTL);
        }

        refreshForm(elm.closest("form") as HTMLFormElement);
      });
    });
  };

  const refreshForm = (form: HTMLFormElement) => {
    postForm(form).then(
      html => {
        const container = document.getElementById("contact-form-wrapper") as HTMLElement;

        container.outerHTML = html;

        //based om updated DOM set values to contact form
        const valueOfEnqueryForm = document
          .querySelector("[data-js-selections]")
          ?.getAttribute("data-js-selections");
        if (valueOfEnqueryForm) {
          document
            .querySelector("[data-js-hidden-enquery-field]")
            ?.setAttribute("value", "__HiddenSelections__," + valueOfEnqueryForm);
        }

        initialize();
      },
      error => {
        console.error("Failed to refresh contact form", error);
      }
    );
  };

  const configureForm = () => {
    // Prevent POST of form, as we'll do it async (AJAX)
    const form = document.getElementById("contact-form") as HTMLFormElement;

    //Prevent duplicate query handlers
    if (!form.action.includes("?handler=Submission")) {
      form.action =
        document
          .querySelector("[data-js-submission-url]")
          ?.getAttribute("data-js-submission-url") + "?handler=Submission";
    }

    form.onsubmit = event => {
      event.preventDefault();
    };

    // Prevent form from being submitted by hitting Enter
    form.addEventListener("keydown", event => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    });

    // Display form when there are no more dropdowns (display-custom-contact-form is only available when first form is completed)
    const hiddenContactForm = document.getElementById("custom-contact-form");
    if (document.getElementById("display-custom-contact-form") != null) {
      hiddenContactForm?.classList.remove("hidden");
    } else {
      hiddenContactForm?.classList.add("hidden");
    }
  };

  /** Sets up behaviors after page load/refresh. */
    const initialize = () => {
        configureForm();
        wireUpSelectElements();
    };

  initialize();
};
